import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import GdvAccessFormComponent from "@/modules/Gdv/components/GdvAccessFormComponent.vue";
import SogPage from "@/shared/ui/SogPage.vue";
import GdvAccess from "@/shared/model/GdvAccess";
import apiGdv from "@/modules/Gdv/api";
import {onMounted, reactive, ref} from "vue";
import {useSpinner} from "@/shared/composables/SogSpinner";
import {useNavigationStore} from "@/modules/Navigation/store";
import {RouteLocationNormalizedLoaded, useRoute, useRouter} from "vue-router";
import copyTo from "@/shared/utils/CopyTo";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import {useGdvStore} from "@/modules/Gdv/store";
import notificationService from "@/shared/services/NotificationService";
import {computed} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GdvAccesEditPage',
  setup(__props) {


const _gdvStore = useGdvStore();
const _gdvAccess = reactive<GdvAccess>(new GdvAccess())
const _spinner = useSpinner();
const _navigationStore = useNavigationStore();
const _router = useRouter();
const _form = ref<InstanceType<typeof GdvAccessFormComponent> | null>()
const _action = ref("");
const _title = ref("");
const _isCreate = computed(() => _action.value === "create");

function p_setTitle() {
  _title.value = "";
  if (_action.value === "edit") {
    _title.value = "Gdv-Zugang bearbeiten"
  }
  if (_action.value === "create") {
    _title.value = "Gdv-Zugang anlegen"
  }

}

async function p_init(route: RouteLocationNormalizedLoaded) {
  _action.value = route.params.action as string ?? "";
  if (_action.value === 'edit' && (!_navigationStore.currentGdvAccessId || !_gdvStore.gdvAccess || _navigationStore.currentGdvAccessId !== _gdvStore.gdvAccess.id)) {
    _router.back()
    return;
  }
  try {
    _spinner.show()
    {
//      copyTo(_clipboardStore.gdvaccess, _gdvAccess.value)
      copyTo(_gdvStore.gdvAccess, _gdvAccess)
    }
  } finally {
    _spinner.hide()
  }
  p_setTitle()
}


//_gdvAccess.value  _clipboardStore.gdvaccess;
onMounted(async () => {
  const route = useRoute();
  await p_init(route)
  //console.log(_gdvAccess)

})

function onCancel() {
  _router.back()
}

async function onSave() {
  if (_action.value === "create" && !_form.value.getResults().id) {
    notificationService.error("Bitte eine ID eingeben");
    return
  }
  if (_form.value && _form.value.validate()) {
    const result = _form.value.getResults();
    const res = await apiGdv.update(result);
    if (res) {
      notificationService.success("Änderung wurde erfolgreich gespeichert")
      _router.back()
    }
    return
  }

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: _title.value
  }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(GdvAccessFormComponent, {
                ref_key: "_form",
                ref: _form,
                data: _gdvAccess,
                "is-create": _isCreate.value
              }, null, 8, ["data", "is-create"])
            ]),
            _: 1
          }),
          _createVNode(SogCardActions, null, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Save,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onSave()))
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" Speichern ", -1)
                ]))]),
                _: 1
              }, 8, ["kind"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Cancel,
                onClick: onCancel
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" Abbrechen ", -1)
                ]))]),
                _: 1
              }, 8, ["kind"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})